import { render, staticRenderFns } from "./units-table.vue?vue&type=template&id=72a61f42&"
import script from "./units-table.vue?vue&type=script&lang=js&"
export * from "./units-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports